import React from "react";
import ApplicationForm from "./ApplicationForm";

const Home = () => {
  return <ApplicationForm />;
};

export default Home;
